import { RefObject, useEffect } from 'react';

export default function useDraggableScroll(sliderRef: RefObject<HTMLElement>) {
  useEffect(() => {
    if (!sliderRef || !sliderRef.current) {
      return;
    }

    const slider = sliderRef.current;

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    const dragstart = (event: MouseEvent) => {
      event.preventDefault();
      isDragging = true;
      startX = event.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;

      addPreventClickAfterMouseup();
      slider.addEventListener('mousemove', mousemove);
    };

    const mousemove = (event: MouseEvent) => {
      if (!isDragging) {
        return;
      }

      event.preventDefault();
      const x = event.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1;
      slider.scrollLeft = scrollLeft - walk;
    };

    const mouseleave = () => {
      isDragging = false;
      slider.removeEventListener('mousemove', mousemove);
    };

    const mouseup = () => slider.removeEventListener('mousemove', mousemove);

    slider.addEventListener('dragstart', dragstart);
    slider.addEventListener('mouseleave', mouseleave);
    slider.addEventListener('mouseup', mouseup);

    return () => {
      slider.removeEventListener('dragstart', dragstart);
      slider.removeEventListener('mousemove', mousemove);
      slider.removeEventListener('mouseleave', mouseleave);
      slider.removeEventListener('mouseup', mouseup);
      removePreventClickAfterMouseup();
    };
  }, [sliderRef]);
}

const preventClickAfterMouseup = (event: MouseEvent) => {
  event.stopPropagation();
  removePreventClickAfterMouseup();
};

const addPreventClickAfterMouseup = () =>
  document.addEventListener('click', preventClickAfterMouseup, {
    capture: true,
  });

const removePreventClickAfterMouseup = () =>
  document.removeEventListener('click', preventClickAfterMouseup, {
    capture: true,
  });
